// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password-container {
  width: 100%;
  height: 100%;
}
.forgot-password-container .inner-container {
  width: 40vh;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/auth/components/forgot-password/forgot-password.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;AACD;AACC;EACC,WAAA;AACF","sourcesContent":[".forgot-password-container {\n\twidth: 100%;\n\theight: 100%;\n\n\t.inner-container {\n\t\twidth: 40vh;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
